// TeeInBlue cart-added flow.
// Track Buy-now intent so we can let the SDK route the user to checkout itself.
const TEE_ATC_HANDOFF_DELAY_MS = 900;

document.addEventListener('teeinblue-event-component-injected', function () {
  globalThis.__tee_buy_now = false;
  const buyNowButton = document.getElementById('teeBuynowButton');
  if (buyNowButton && buyNowButton.dataset.popupBound !== 'true') {
    buyNowButton.dataset.popupBound = 'true';
    buyNowButton.addEventListener('click', function () {
      globalThis.__tee_buy_now = true;
    });
  }
});

function getCartUrl() {
  const root = globalThis.Shopify?.routes?.root || '/';
  return `${root.endsWith('/') ? root : `${root}/`}cart`;
}

function hideTeeConfirmModal() {
  const modal = document.getElementById('tee_add_to_cart_confirm');
  if (modal) {
    modal.style.display = 'none';
  }
}

function deferTeeAtcHandoff(callback) {
  globalThis.setTimeout(callback, TEE_ATC_HANDOFF_DELAY_MS);
}

function openMiniCartAfterTeeAdd() {
  const miniCart = globalThis.CAFMiniCartDrawer;
  if (!miniCart || typeof miniCart.fetchRefreshAndOpen !== 'function') return false;
  if (typeof miniCart.canOpen === 'function' && !miniCart.canOpen()) return false;

  miniCart.fetchRefreshAndOpen().then(function (opened) {
    if (!opened) {
      globalThis.location.href = getCartUrl();
    }
  }).catch(function () {
    globalThis.location.href = getCartUrl();
  });

  return true;
}

// After the Tee customizer confirms an add, use the CAF mini-cart drawer as
// the cart surface. If the drawer API is unavailable, keep /cart as fallback.
// Buy Now still bypasses this — the SDK takes care of routing to checkout.
document.addEventListener('teeinblue-event-after-cart-added', function () {
  if (globalThis.__tee_buy_now) {
    globalThis.__tee_buy_now = false;
    return;
  }

  hideTeeConfirmModal();
  deferTeeAtcHandoff(function () {
    if (!openMiniCartAfterTeeAdd()) {
      globalThis.location.href = getCartUrl();
    }
  });
});
